let eventMap = {}
let eventCatch = []
export default {
    /** 事件触发 */
    emit(eventName, payload, isCatch) {
        if (!eventMap[eventName] && !isCatch) {
            return console.warn(
                `事件：${eventName}，被触发了，但是无监听者。事件内容为：${payload}`
            )
        } else if (!eventMap[eventName] && isCatch) {
            this.eventCatch(eventName, payload)
            return
        }
        // console.log(eventCatch)
        for (let item of eventMap[eventName].values()) {
            item(payload)
        }
    },
    /** 事件监听 */
    eventCatch(eventName, payload) {
        eventCatch.push({
            eventName,
            payload
        })
    },
    /** 事件监听 */
    on(eventName, handler) {
        if (typeof handler === 'function') {
            if (!eventMap[eventName]) eventMap[eventName] = new Set()
            eventMap[eventName].add(handler)
        }
        if (eventCatch.length) {
            for (let i = 0; i < eventCatch.length; i++) {
                if (eventCatch[i].eventName === eventName) {
                    handler(eventCatch[i].payload)
                    eventCatch.splice(i, 1)
                    i--
                }
            }
        }
    },
    /** 取消事件监听 */
    off(eventName, handler) {
        if (!handler) return console.warn(`取消监听必须传入已被监听的事件处理函数`)
        eventMap[eventName].delete(handler)
    },
    /** 清理事件总线 */
    clean() {
        eventMap = {}
    },
    /** 获取当前事件总线详情 */
    getEvents() {
        return eventMap
    },
    getEventCatch() {
        return eventCatch
    }
}